import {
    DimensionType,
    IHierarchy,
    IHierarchyChangeEvent,
    IHierarchyLevel,
    IHierarchyNode
} from "../PA.Core/PA.Core.IF.Hierarchy";
import {IMessageProvider} from "../PA.Core/PA.Core.IF.Basic";
import {MessageProvider} from "../PA.Core/Basic/Messages";
import {WB_SimulationRow} from "../PA.Core/PAdbSchemaRows";
import {IHaveSimulationCollection} from "../PA.Simulation.Core/PA.Simulation.IF.Aspects";
import * as _ from "lodash"
import {BehaviorSubject} from "rxjs";

export class SimulationHierarchy
    implements
        IHierarchy
{
    private messageProvider: MessageProvider
    private arrlevels: IHierarchyLevel[]
    private dctNodes: {[id:string]: IHierarchyNode}
    private hierarchyChanged: BehaviorSubject<IHierarchyChangeEvent>
    private arrWBSimulationRows: WB_SimulationRow[] = undefined
    private simulationCollection: IHaveSimulationCollection = undefined

    constructor(options?: {simulationCollection?: IHaveSimulationCollection, arrWBSimulationRows?: WB_SimulationRow[] }) {
        const self = this
        this.messageProvider = new MessageProvider();
        this.dctNodes = {}
        this.arrlevels = [{LevelId: "Simulation", LevelName: "Simulation", LevelDepth: 0}]
        this.hierarchyChanged = new BehaviorSubject<IHierarchyChangeEvent>({hierarchy: self, change: "init"})

        this.arrWBSimulationRows = options?.arrWBSimulationRows || []
        this.simulationCollection = options?.simulationCollection


        if(this.simulationCollection){
            this.arrWBSimulationRows = this.simulationCollection.Simulations
            this.simulationCollection.OnSimulationCollectionChanged.subscribe((a) => {
                this.arrWBSimulationRows = a.Simulations
                this.dctNodes = {}
                _.forEach(this.arrWBSimulationRows, (aRow) => {
                    self.dctNodes[aRow.cif.WB_SIMULATION_ID]
                        = {NodeId: aRow.cif.WB_SIMULATION_ID + '',
                           NodeIdUI: aRow.cif.SIMULATION_ID,
                           NodeName: aRow.cif.SIMULATION_NAME,
                           NodeLevel: "Simulation",
                           NodeShortName: aRow.cif.SIMULATION_NAME,
                           bHasSourceKey: true,
                           SourceKey: aRow.cif.WB_SIMULATION_ID,
                           SourceKeyType: "Simulation"
                    }
                })
                self.hierarchyChanged.next({hierarchy: self, change: "nodes"})
            })
        }

        if(!_.isEmpty(this.arrWBSimulationRows)){
            this.dctNodes = {}
            _.forEach(this.arrWBSimulationRows, (aRow) => {
                self.dctNodes[aRow.cif.WB_SIMULATION_ID]
                    = {NodeId: aRow.cif.WB_SIMULATION_ID + '',
                       NodeIdUI: aRow.cif.SIMULATION_ID,
                       NodeName: aRow.cif.SIMULATION_NAME,
                       NodeLevel: "Simulation",
                       NodeShortName: aRow.cif.SIMULATION_NAME,
                       bHasSourceKey: true,
                       SourceKey: aRow.cif.WB_SIMULATION_ID,
                       SourceKeyType: "Simulation"
                    }
            })
            self.hierarchyChanged.next({hierarchy: self, change: "init"})
        }


    }

    get DimensionType(): DimensionType {
        return DimensionType.PromotionPlan
    }

    get HierarchyId(): string {
        return "Simulation"
    }

    get HierarchyIdUI(): string {
        return "Simulation"
    }

    get HierarchyName(): string {
        return "Simulation"
    }

    get LoadMessageProvider(): IMessageProvider {
        return this.messageProvider
    }

    get OnLoadComplete(): Promise<void> {
        return Promise.resolve()
    }

    get bLoaded(): boolean {
        return true
    }

    get HierarchyChanged(): BehaviorSubject<IHierarchyChangeEvent> {
        return this.hierarchyChanged
    }

    getChildren(nodes: IHierarchyNode[] | IHierarchyNode | string[] | string, levelId?: string): IHierarchyNode[] {
        return [];
    }

    getLevels(): IHierarchyLevel[] {
        return this.arrlevels;
    }

    getNode(NodeId: string): IHierarchyNode {
        return this.dctNodes[NodeId];
    }

    getNodes(): IHierarchyNode[] {
        return _.values(this.dctNodes)
    }


    getNodesAtLevel(HierarchyLevel: string): IHierarchyNode[] {
        if(HierarchyLevel == "Simulation")
            return _.values(this.dctNodes)

        return [];
    }

    getParents(nodes: IHierarchyNode[] | IHierarchyNode | string[] | string, levelId?: string): { [p: string]: IHierarchyNode } {
        return {};
    }

    getTopLevelNodes(): IHierarchyNode[] {
        return _.values(this.dctNodes);
    }


}